import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function CartIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" {...props}>
        <path d="M7.8 9.374h9.252a.77.77 0 0 0 .726-.5l2.174-6.025a.76.76 0 0 0-.095-.694.77.77 0 0 0-.63-.322H5.318L4.794.487A.77.77 0 0 0 4.075 0H.77A.765.765 0 0 0 0 .76a.765.765 0 0 0 .77.76h2.777l2.8 7.167-1.1 2.475a.75.75 0 0 0 .06.723.77.77 0 0 0 .645.344H17.99a.76.76 0 1 0 0-1.52H7.123l.6-1.351a1 1 0 0 0 .077.016M5.911 3.349h12.227l-1.626 4.5H7.8a1 1 0 0 0-.125.025z" />
        <ellipse
          cx={2.054}
          cy={2.027}
          fill="none"
          rx={2.054}
          ry={2.027}
          transform="translate(5.565 12.946)"
        />
        <path d="M7.619 12.946a2.027 2.027 0 1 0 2.054 2.027 2.043 2.043 0 0 0-2.054-2.027m0 2.534a.507.507 0 1 1 .514-.507.51.51 0 0 1-.514.507" />
        <ellipse
          cx={2.054}
          cy={2.027}
          fill="none"
          rx={2.054}
          ry={2.027}
          transform="translate(13.782 12.946)"
        />
        <path d="M15.836 12.946a2.027 2.027 0 1 0 2.054 2.027 2.04 2.04 0 0 0-2.054-2.027m0 2.534a.507.507 0 1 1 .513-.507.51.51 0 0 1-.513.507" />
      </svg>
    </Icon>
  )
}
export default CartIcon
